import { render } from "./DhDuration.vue?vue&type=template&id=e576bd30"
import script from "./DhDuration.vue?vue&type=script&lang=ts"
export * from "./DhDuration.vue?vue&type=script&lang=ts"
script.render = render

export default script